<template>
  <CardToMobileLayout v-if="formFields.length" title="Home Address">
    <div class="row">
      <template v-for="field in formFields" :key="field.attrs.name">
        <component
          :is="field.comp"
          :model-value="form[field.attrs.name]"
          v-bind="field.attrs"
          :rules="field.rules"
          :form-name="formName"
          @update:model-value="form[field.attrs.name] = $event"
        />
      </template>
    </div>
  </CardToMobileLayout>
</template>

<script setup lang="ts">
import { inject } from "vue";

import { Application } from "../types";
import { GeneratedField } from "../useFieldGenerator";

interface Props {
  formName: string;
  formFields: GeneratedField[];
}

defineProps<Props>();
const form = inject("form") as Application;
</script>
